<script>
import LayoutMain from "@/router/layouts/main";
import LayoutExperts from "@/router/layouts/experts";
import { api } from "@/state/services";

export default {
  components: {
    LayoutMain,
    LayoutExperts,
  },
  data() {
    return {
      loading: true,
      errored: false,
      message: '',
      timer: null,

      voucher: {
        code: '',
        loading: false,
      },

      order: {
        id: this.$route.params.id,
        date: null,
        expires: null,
        total: '0.00',
        payment: {
          status: 'pending',
          methods: [],
          list: [],
        },
        plan: {
          name: '',
          description: '',
          type: 0,
          status: '',
          due_date: '',
        },
      },

      creditcard: {
        loading: false,
        modal: false,
        ip: '',
        installments: [],
        installment: '1',
        number: '',
        holderName: '',
        expiryMonth: '',
        expiryYear: '',
        cvv: '',
      },
    };
  },
  computed: {
    // Sem plano do Experts ativo usa o layout sem menu; com plano ativo mantém o menu
    layout() {
      const user = this.$store.state.account.user;
      return user && user.expert == 'active' ? 'LayoutMain' : 'LayoutExperts';
    },
  },
  methods: {
    getOrder(silent) {
      if (!this.order.id) {
        return;
      }

      api
        .get('experts/order/' + this.order.id)
        .then(response => {
          // Resposta inválida (ex.: erro do servidor fora do JSON)
          if (!response.data || typeof response.data !== 'object') {
            if (!silent) {
              this.errored = true;
            }
            return;
          }

          if (response.data.status == 'success') {
            this.order = response.data.order;

            if (this.order.payment.status == 'pending' && this.order.payment.methods && this.order.payment.methods.creditcard) {
              this.creditcard.installments = this.order.payment.methods.creditcard.installments;
            }

            this.errored = false;
            this.schedule();

            // Pago: atualiza o usuário para liberar o menu
            if (this.order.payment.status == 'approved') {
              this.refreshUser();
            }
          } else {
            this.message = response.data.message || 'A fatura não foi encontrada.';
          }
        })
        .catch(() => {
          if (!silent) {
            this.errored = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Enquanto aguarda o pagamento, consulta a fatura a cada 10 segundos
    schedule() {
      clearTimeout(this.timer);
      if (this.order.payment.status == 'pending' || (this.order.payment.status == 'approved' && this.order.plan.status != 'approved')) {
        this.timer = setTimeout(() => this.getOrder(true), 10000);
      }
    },
    refreshUser() {
      api.get('user').then(response => {
        if (response.data && response.data.status == 'success') {
          this.$store.state.account.user = response.data.user;
        }
      });
    },
    payCreditCard() {
      this.creditcard.loading = true;
      this.creditcard.modal = true;

      api
        .post('store/orders/' + this.order.id + '/creditcard', {
          installment: this.creditcard.installment,
          number: this.creditcard.number,
          holderName: this.creditcard.holderName,
          expiryMonth: this.creditcard.expiryMonth,
          expiryYear: this.creditcard.expiryYear,
          cvv: this.creditcard.cvv,
          ip: this.creditcard.ip,
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(response.data.message || 'O pagamento foi realizado com sucesso.');
            this.getOrder();
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao processar o pagamento, tente novamente.');
        })
        .finally(() => {
          this.creditcard.loading = false;
          this.creditcard.modal = false;
        });
    },
    applyVoucher() {
      this.voucher.loading = true;

      api
        .post('experts/voucher', {
          id_order: this.order.id,
          code: this.voucher.code.trim().toUpperCase(),
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(response.data.message);
            this.voucher.code = '';
            this.getOrder();
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao aplicar o voucher, tente novamente.');
        })
        .finally(() => {
          this.voucher.loading = false;
        });
    },
    getIp() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          if (data.ip) {
            this.creditcard.ip = data.ip;
          }
        })
        .catch(() => { });
    },
  },
  mounted() {
    this.getOrder();
    this.getIp();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<template>
  <component :is="layout">
    <div class="experts">
      <router-link to="/experts" class="experts-back">
        <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> Voltar aos planos
      </router-link>

      <div v-if="loading" class="text-center py-5">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else-if="errored" class="experts-box text-center">
        <p>Pedimos desculpas, não podemos recuperar a fatura neste momento.</p>
        <button class="btn btn-default" v-on:click="loading = true; errored = false; getOrder()">Tentar novamente</button>
      </div>
      <div v-else-if="message" class="experts-box text-center">
        <p>{{ message }}</p>
        <router-link tag="a" to="/experts" class="btn btn-default">Ver planos</router-link>
      </div>

      <!-- Pago -->
      <div v-else-if="order.payment.status == 'approved'" class="experts-box experts-result text-center">
        <template v-if="order.plan.status == 'approved'">
          <i class="bx bx-check-circle experts-result-icon" aria-hidden="true"></i>
          <h1 class="experts-title">Plano ativado!</h1>
          <p class="experts-subtitle mb-4">Seu plano <strong>{{ order.plan.name }}</strong> é válido até {{ order.plan.due_date }}.</p>
          <router-link tag="a" to="/" class="btn btn-default btn-lg btn-block text-uppercase">
            Começar a usar
          </router-link>
        </template>
        <template v-else>
          <b-spinner variant="default" role="status"></b-spinner>
          <h1 class="experts-title mt-3">Pagamento recebido</h1>
          <p class="experts-subtitle mb-0">Estamos ativando o seu plano. Isso leva poucos instantes.</p>
        </template>
      </div>

      <!-- Cancelada ou expirada -->
      <div v-else-if="order.payment.status == 'canceled'" class="experts-box experts-result text-center">
        <i class="bx bx-x-circle experts-result-icon" aria-hidden="true"></i>
        <h1 class="experts-title">Fatura cancelada</h1>
        <p class="experts-subtitle mb-4">Esta fatura foi cancelada ou expirou. Escolha um plano para gerar uma nova.</p>
        <router-link tag="a" to="/experts" class="btn btn-default btn-lg btn-block text-uppercase">
          Escolher plano
        </router-link>
      </div>

      <!-- Aguardando pagamento -->
      <div v-else>
        <div class="experts-intro">
          <h1 class="experts-title">Pague sua fatura</h1>
          <p class="experts-subtitle">Escolha a forma de pagamento. O plano é ativado assim que o pagamento for confirmado.</p>
        </div>

        <div class="experts-confirm">
          <div class="experts-col">
          <!-- Resumo da fatura -->
          <div class="experts-box experts-summary">
            <div class="d-flex justify-content-between align-items-start mb-3">
              <h5 class="mb-0">Fatura #{{ order.id }}</h5>
              <span class="badge badge-soft-danger font-size-12">AGUARDANDO PAGAMENTO</span>
            </div>
            <dl>
              <div>
                <dt>Plano</dt>
                <dd>{{ order.plan.name }}</dd>
              </div>
              <div>
                <dt>Vigência</dt>
                <dd>12 meses</dd>
              </div>
              <div>
                <dt>Gerada em</dt>
                <dd>{{ order.date }}</dd>
              </div>
              <div>
                <dt>Vence em</dt>
                <dd>{{ order.expires }}</dd>
              </div>
              <div class="is-total">
                <dt>Total</dt>
                <dd>{{ order.total | currency }}</dd>
              </div>
            </dl>
            <router-link tag="a" to="/experts" class="btn btn-outline-default btn-lg btn-block text-uppercase">
              Trocar plano ou cancelar
            </router-link>
          </div>

          <!-- Voucher -->
          <div class="experts-box experts-voucher">
            <h5 class="mb-1">Possui um voucher?</h5>
            <p class="text-muted font-size-13 mb-3">Informe o código para ativar o plano.</p>
            <form @submit.prevent="applyVoucher">
              <input v-model="voucher.code" type="text" class="form-control form-control-lg text-uppercase mb-2" placeholder="MB-XXXXX-0000" maxlength="20" :disabled="voucher.loading" />
              <button type="submit" class="btn btn-default btn-lg btn-block text-uppercase" :disabled="voucher.loading || !voucher.code">
                <b-spinner v-if="voucher.loading" small class="mr-1"></b-spinner>
                Aplicar voucher
              </button>
            </form>
          </div>
          </div>

          <!-- Formas de pagamento -->
          <div class="experts-box">
            <h5 class="mb-0">Forma de pagamento</h5>
            <p v-if="!order.payment.methods || Object.keys(order.payment.methods).length == 0" class="text-muted mt-3 mb-0">
              Nenhuma forma de pagamento disponível no momento. Tente novamente em instantes.
            </p>
            <b-tabs v-else justified nav-class="nav-tabs-custom mt-2" content-class="pt-3">
                <b-tab v-for="(pay, method) in order.payment.methods" :key="method">
                  <template v-slot:title>{{ pay.name }}</template>

                  <div v-if="method == 'pix'" class="text-center">
                    <div v-if="pay.pix && pay.pix.text">
                      <div v-if="pay.pix.image">
                        <p class="mb-3">Use o código QR para pagar.</p>
                        <div class="mb-3 d-flex justify-content-center">
                          <div class="border rounded p-3">
                            <img style="width: 180px; max-width: 100%;" :src="'data:image/png;base64,' + pay.pix.image" />
                          </div>
                        </div>
                        <p>Ou utilize o Pix Copia e Cola.</p>
                      </div>
                      <p v-else>Use o Pix Copia e Cola para pagar.</p>
                      <fieldset class="text-break py-3 mb-3">{{ pay.pix.text }}</fieldset>
                      <button class="btn btn-default btn-lg btn-block text-uppercase" v-clipboard:copy="pay.pix.text"
                        v-on:click="$toast.success('<strong>Copiado para a área de transferência.</strong><br>Agora, acesse o aplicativo do seu banco e conclua o pagamento usando o <strong>Pix Copia e Cola</strong>.')">
                        Copiar Pix Copia e Cola
                      </button>
                      <p class="text-muted mt-3 mb-0">
                        <b-spinner small class="mr-1 align-middle" variant="default" role="status"></b-spinner>
                        Aguardando a confirmação do pagamento…
                      </p>
                    </div>
                  </div>

                  <div v-else-if="method == 'creditcard'">
                    <b-form @submit.prevent="payCreditCard">
                      <b-form-group label="Número de Parcelas" label-for="installment">
                        <b-form-select id="installment" v-model="creditcard.installment" :options="creditcard.installments" required></b-form-select>
                      </b-form-group>
                      <b-form-group label="Número do Cartão" label-for="number">
                        <b-form-input id="number" v-model="creditcard.number" type="text" inputmode="numeric" autocomplete="cc-number" required v-mask="'#### #### #### ####'"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Nome do Titular" label-for="holderName">
                        <b-form-input id="holderName" v-model="creditcard.holderName" type="text" autocomplete="cc-name" required></b-form-input>
                      </b-form-group>
                      <div class="row">
                        <div class="col-6">
                          <b-form-group label="Vencimento" label-for="expiryMonth">
                            <b-input-group>
                              <b-form-input id="expiryMonth" v-model="creditcard.expiryMonth" type="text" inputmode="numeric" placeholder="Mês" maxlength="2" required v-mask="'##'"></b-form-input>
                              <b-form-input id="expiryYear" v-model="creditcard.expiryYear" type="text" inputmode="numeric" placeholder="Ano" maxlength="2" required v-mask="'##'"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </div>
                        <div class="col-6">
                          <b-form-group label="Código" label-for="cvv">
                            <b-form-input id="cvv" v-model="creditcard.cvv" type="text" inputmode="numeric" autocomplete="cc-csc" required v-mask="'###'"></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                      <button class="btn btn-default btn-lg btn-block text-uppercase" type="submit" :disabled="creditcard.loading">
                        Pagar {{ order.total | currency }}
                        <b-spinner v-if="creditcard.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                      </button>
                    </b-form>
                  </div>
                </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="creditcard.modal" modal-class="modal-center" hide-header hide-footer centered no-close-on-backdrop no-close-on-esc>
      <div class="text-center py-4">
        <div class="d-flex justify-content-center align-items-center mb-4">
          <b-spinner large class="align-middle" variant="default" role="status"></b-spinner>
        </div>
        <h5>Aguarde!</h5>
        <h6>Estamos processando o seu pagamento!</h6>
      </div>
    </b-modal>
  </component>
</template>
